import React, { useState, useEffect } from 'react'
import ContactStyle from './ContactStyle'
import emailjs from 'emailjs-com'

//validate email, add env variables, add success message

const Contact = () => {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')
  const [validEmail, setValidEmail] = useState(true)
  const [isSuccess, setIsSuccess] = useState('')

  //validate
  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    setValidEmail(regex.test(email))
    return regex.test(email)
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (validateEmail(email)) {
      //Configure EmailJS with your service ID, template ID, and user ID
      emailjs.init('B5Hmt7rgTypiDdL8S')

      // Prepare the email template parameters
      const templateParams = {
        from_name: name,
        from_email: email,
        message: message + ' ' + email,
      }

      // Send the email
      emailjs
        .send('service_zf7fdeo', 'template_7f36zeh', templateParams)
        .then((response) => {
          console.log('Email sent!', response)
          setName('')
          setEmail('')
          setMessage('')
          setIsSuccess('Message sent!')
        })
        .catch((error) => {
          //add error message
          console.error('Error sending email:', error)
          setIsSuccess('Error sending message')
        })
    }
  }

  useEffect(() => {
    let timeout

    if (isSuccess) {
      timeout = setTimeout(() => {
        setIsSuccess('')
      }, 5000)
    }

    return () => {
      clearTimeout(timeout)
    }
  }, [isSuccess])

  return (
    <ContactStyle>
      <div className="contact-container">
        <h3>Contact Us</h3>
        <div className="input-container my-4">
          <input
            type="text"
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onBlur={() => validateEmail(email)}
            className={validEmail ? '' : 'invalid'}
          />
        </div>
        <textarea
          placeholder="What can we help you with?"
          className="mb-4"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
        <button type="submit" onClick={handleSubmit}>
          Send Message
        </button>
        {isSuccess === 'Message sent!' && (
          <p className="sent-message">{isSuccess}</p>
        )}
        {isSuccess === 'Error sending message' && (
          <p className="sent-message error-message">{isSuccess}</p>
        )}
      </div>
    </ContactStyle>
  )
}

export default Contact
